/* eslint-disable */
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Chip,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import RemoveCircleOutlineOutlinedIcon from "@mui/icons-material/RemoveCircleOutlineOutlined";
import { useEffect, useState } from "react";
import { getConfiguracion } from "../../services/ConfiguracionService";
import { v4 as uuidv4 } from 'uuid';
import WaitingDialog from "../../utils/WaitingDialog";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { useMemo } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Tooltip } from "@mui/material";

const initialState = {
  esfera: 0,
  cilindro: 0,
  eje: 0,
};

const nameItemText = "Correcciones por Rango";
//
// ########################################################################### 
//
const CorreccionesDialog = ({
  onSave,
  onClose,
  itemCrud,
  actionCrud,
  setMessage,
  setShowMessage
}) => {
  const [itemCrudLocal, setItemCrudLocal] = useState(initialState);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  // Estado para Autocomplete de Esfera
  const [esferaOptions, setEsferaOptions] = useState([]);
  const [valueACEsfera, setValueACEsfera] = useState([]);
  const [inputValueACEsfera, setInputValueACEsfera] = useState("");
  // Estado para Autocomplete de Cilindro
  const [cilindroOptions, setCilindroOptions] = useState([]);
  const [valueACCilindro, setValueACCilindro] = useState([]);
  const [inputValueACCilindro, setInputValueACCilindro] = useState("");
  // Estado para Autocomplete de Ejes
  const [ejeOptions, setEjeOptions] = useState([]);
  const [valueACEje, setValueACEje] = useState([]);
  const [inputValueACEje, setInputValueACEje] = useState("");
  const [correccionesList, setCorreccionesList] = useState([]);

  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;

  const correccionesSorted = useMemo(() => {
    const arr = Array.isArray(itemCrudLocal.correccionesList) ? [...itemCrudLocal.correccionesList] : [];
    arr.sort((a, b) => {
      const ea = Number(a?.esfera ?? 0);
      const eb = Number(b?.esfera ?? 0);
      if (ea !== eb) return ea - eb;
      const ca = Number(a?.cilindro ?? 0);
      const cb = Number(b?.cilindro ?? 0);
      if (ca !== cb) return ca - cb;
      const ja = Number(a?.eje ?? 0);
      const jb = Number(b?.eje ?? 0);
      return ja - jb;
    });
    return arr;
  }, [itemCrudLocal.correccionesList]);

  const tableColumnsCorreccionesList = [
    {
      field: "esfera",
      headerName: "Esfera",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => (
        <span style={{ fontSize: "0.9em" }}>{params.row.esfera != null && params.row.esfera !== '' ? Number(params.row.esfera) : 0}</span>
      ),
    },
    {
      field: "cilindro",
      headerName: "Cilindro",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => (
        <span style={{ fontSize: "0.9em" }}>{params.row.cilindro != null && params.row.cilindro !== '' ? Number(params.row.cilindro) : 0}</span>
      ),
    },
    {
      field: "eje",
      headerName: "Eje",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => (
        <span style={{ fontSize: "0.9em" }}>{params.row.eje != null && params.row.eje !== '' ? Number(params.row.eje) : 0}</span>
      ),
    },
    {
      field: "actions",
      headerName: "Acciones",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <Tooltip title="Quitar Corrección">
          <IconButton
            size="small"
            aria-label="delete"
            onClick={() => handleClickCorreccion(params.row, "delete")}
          >
            <RemoveCircleOutlineOutlinedIcon />
          </IconButton>
        </Tooltip>
      ),
    },
  ];

  const tableOptionsCorreccionesList = {
    rowHeight: 35,
    columnHeaderHeight: 40,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    disableRowSelectionOnClick: true,
    getRowId: (row) => row.id || `${row.esfera}-${row.cilindro}-${row.eje}`,
    hideFooter: true,
    localeText: {
      noRowsLabel: "",
    },
    sx: {
      '& .MuiDataGrid-cell': {
        fontSize: '0.9em',
      },
      '& .MuiDataGrid-columnHeaders': {
        backgroundColor: '#f5f5f5',
      },
    },
  };
  //
  // ################################################################################
  //
  useEffect(() => {
    if (itemCrud && itemCrud.correccionesList) {
      setCorreccionesList(itemCrud.correccionesList);
    } else {
      setCorreccionesList([]);
    }

    loadConfiguracion();
    buildEsferaOptions();
    buildCilindroOptions();
    buildEjeOptions();
    if (actionCrud === "new") {
      setItemCrudLocal(initialState);
    } else {
      setItemCrudLocal(itemCrud);
    }
  }, []);

  // reconstruyo opciones de Esfera cuando cambian los límites del rango
  useEffect(() => {
    buildEsferaOptions();
  }, [itemCrudLocal.esferaDesde, itemCrudLocal.esferaHasta]);

  // reconstruyo opciones de Cilindro cuando cambian los límites del rango
  useEffect(() => {
    buildCilindroOptions();
  }, [itemCrudLocal.cilindroDesde, itemCrudLocal.cilindroHasta]);

  //
  // ################################################################################
  //
  const loadConfiguracion = async () => {
    setIsDoingSomething(true);
    const response = await getConfiguracion();
    if (response.ok) {
      setIsDoingSomething(false);
      let _response = response.data.data;
      setItemCrudLocal((prev) => ({
        ...prev,
        valorDolar: _response[0].valor_dolar,
        tasaIva: _response[0].valor_tasa_iva_lc,
      }));
    } else {
      setIsDoingSomething(false);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  // Opciones de Esfera Que esten dentro del rango que viene seteado..
  //
  const buildEsferaOptions = () => {
    const toNum = (val, fallback) => {
      const n = Number(val);
      return Number.isFinite(n) ? n : fallback;
    };
    // límites del dominio permitido
    const minDomain = -30;
    const maxDomain = 30;
    let minSel = toNum(itemCrudLocal.esferaDesde, minDomain);
    let maxSel = toNum(itemCrudLocal.esferaHasta, maxDomain);
    // normalizo si vienen invertidos
    if (minSel > maxSel) {
      const tmp = minSel; minSel = maxSel; maxSel = tmp;
    }
    // acoto al dominio [-30, 30]
    minSel = Math.max(minDomain, Math.min(maxDomain, minSel));
    maxSel = Math.max(minDomain, Math.min(maxDomain, maxSel));

    // genero todas las opciones y filtro por el rango seleccionado
    const all = [];
    for (let v = minDomain; v <= maxDomain + 1e-9; v += 0.25) {
      const value = Number(v.toFixed(2));
      all.push({ id: value, label: value.toFixed(2) });
    }
    const inRange = all.filter(opt => opt.id >= minSel && opt.id <= maxSel);
    setEsferaOptions(inRange);
    // elimino valores seleccionados que queden fuera del nuevo rango
    setValueACEsfera(prev =>
      Array.isArray(prev) ? prev.filter(sel => inRange.some(o => o.id === sel.id)) : []
    );
  };

  const esferaOptionsWithActions = useMemo(() => {
    return [
      { id: "__toggle_all__", label: "Seleccionar todos", __action: true },
      ...(esferaOptions || []),
    ];
  }, [esferaOptions]);

  const allEsferasSelected = useMemo(() => {
    return (
      Array.isArray(esferaOptions) &&
      esferaOptions.length > 0 &&
      Array.isArray(valueACEsfera) &&
      valueACEsfera.length === esferaOptions.length
    );
  }, [esferaOptions, valueACEsfera]);

  const handleSelectAllEsferas = () => {
    if (Array.isArray(esferaOptions) && esferaOptions.length > 0) {
      setValueACEsfera(esferaOptions);
    }
  };

  const handleClearAllEsferas = () => {
    setValueACEsfera([]);
  };

  const cilindroOptionsWithActions = useMemo(() => {
    return [
      { id: "__toggle_all__", label: "Seleccionar todos", __action: true },
      ...(cilindroOptions || []),
    ];
  }, [cilindroOptions]);

  const allCilindrosSelected = useMemo(() => {
    return (
      Array.isArray(cilindroOptions) &&
      cilindroOptions.length > 0 &&
      Array.isArray(valueACCilindro) &&
      valueACCilindro.length === cilindroOptions.length
    );
  }, [cilindroOptions, valueACCilindro]);

  const handleSelectAllCilindros = () => {
    if (Array.isArray(cilindroOptions) && cilindroOptions.length > 0) {
      setValueACCilindro(cilindroOptions);
    }
  };

  const handleClearAllCilindros = () => {
    setValueACCilindro([]);
  };

  const ejesOptionsWithActions = useMemo(() => {
    return [
      { id: "__toggle_all__", label: "Seleccionar todos", __action: true },
      ...(ejeOptions || []),
    ];
  }, [ejeOptions]);

  const allEjesSelected = useMemo(() => {
    return (
      Array.isArray(ejeOptions) &&
      ejeOptions.length > 0 &&
      Array.isArray(valueACEje) &&
      valueACEje.length === ejeOptions.length
    );
  }, [ejeOptions, valueACEje]);

  const handleSelectAllEjes = () => {
    if (Array.isArray(ejeOptions) && ejeOptions.length > 0) {
      setValueACEje(ejeOptions);
    }
  };

  const handleClearAllEjes = () => {
    setValueACEje([]);
  };
  //
  // ################################################################################
  //
  const handleCloseDialog = () => {
    onClose();
  };
  //
  // ################################################################################
  // Opciones de Cilindro dentro del rango seteado
  //
  const buildCilindroOptions = () => {
    const toNum = (val, fallback) => {
      const n = Number(val);
      return Number.isFinite(n) ? n : fallback;
    };
    const minDomain = -10;
    const maxDomain = 10;
    let minSel = toNum(itemCrudLocal.cilindroDesde, minDomain);
    let maxSel = toNum(itemCrudLocal.cilindroHasta, maxDomain);
    if (minSel > maxSel) {
      const tmp = minSel; minSel = maxSel; maxSel = tmp;
    }
    minSel = Math.max(minDomain, Math.min(maxDomain, minSel));
    maxSel = Math.max(minDomain, Math.min(maxDomain, maxSel));

    const all = [];
    for (let v = minDomain; v <= maxDomain + 1e-9; v += 0.25) {
      const value = Number(v.toFixed(2));
      all.push({ id: value, label: value.toFixed(2) });
    }
    const inRange = all.filter(opt => opt.id >= minSel && opt.id <= maxSel);
    setCilindroOptions(inRange);
    setValueACCilindro(prev =>
      Array.isArray(prev) ? prev.filter(sel => inRange.some(o => o.id === sel.id)) : []
    );
  };
  //
  // ################################################################################
  // Opciones de Ejes 0..180 con una iteracion de 5 en 5
  //
  const buildEjeOptions = () => {
    const opts = [];
    for (let v = 0; v <= 180; v += 5) {
      opts.push({ id: v, label: v.toString() });
    }
    setEjeOptions(opts);
    setValueACEje(prev =>
      Array.isArray(prev) ? prev.filter(sel => opts.some(o => o.id === sel.id)) : []
    );
  };
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    const { name, type, checked, value } = e.target;
    setItemCrudLocal((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };
  //
  // ################################################################################
  //
  const handleClickCorreccion = (item, action) => {
    if (action === "delete" && item && item.id) {
      setItemCrudLocal((prev) => ({
        ...prev,
        correccionesList: (Array.isArray(prev.correccionesList) ? prev.correccionesList : []).filter((c) => c.id !== item.id),
      }));
      setCorreccionesList((prev) => (Array.isArray(prev) ? prev.filter((c) => c.id !== item.id) : []));

    } else {

      if (valueACEsfera.length === 0 || valueACCilindro.length === 0) {
        setMessage({
          severity: "error",
          messageText: "Debes seleccionar Esfera y Cilindro",
        });
        setShowMessage(true);
        return;
      }

      const selectedEsferas = Array.isArray(valueACEsfera) ? valueACEsfera : [];
      const selectedCilindros = Array.isArray(valueACCilindro) ? valueACCilindro : [];
      const selectedEjes = Array.isArray(valueACEje) ? valueACEje : [];

      const currentList = Array.isArray(itemCrudLocal.correccionesList) ? itemCrudLocal.correccionesList : [];

      const exists = (esfera, cilindro, eje) =>
        currentList.some(
          (c) => Number(c.esfera) === Number(esfera) && Number(c.cilindro) === Number(cilindro) && Number(c.eje) === Number(eje)
        );

      const itemsToAdd = [];

      selectedEsferas.forEach((esferaOpt) => {
        selectedCilindros.forEach((cilindroOpt) => {
          const needsEje = Number(cilindroOpt.id) !== 0;
          const ejeCandidates = needsEje ? selectedEjes : [{ id: 0, label: "0" }];
          ejeCandidates.forEach((ejeOpt) => {
            const esfera = esferaOpt.id;
            const cilindro = cilindroOpt.id;
            const eje = ejeOpt.id;
            if (
              !exists(esfera, cilindro, eje) &&
              !itemsToAdd.some((c) => c.esfera === esfera && c.cilindro === cilindro && c.eje === eje)
            ) {
              itemsToAdd.push({ id: uuidv4(), esfera, cilindro, eje });
            }
          });
        });
      });

      if (itemsToAdd.length === 0) {
        return;
      }

      setItemCrudLocal((prev) => ({
        ...prev,
        correccionesList: [...(Array.isArray(prev.correccionesList) ? prev.correccionesList : []), ...itemsToAdd],
      }));
      setCorreccionesList((prev) => [...(Array.isArray(prev) ? prev : []), ...itemsToAdd]);

      setValueACEsfera([]);
      setValueACCilindro([]);
      setValueACEje([]);
    }
  };
  //
  // ################################################################################
  //
  const handleSave = () => {
    save();
  };
  //
  // ########################################################################## 
  //
  const save = async () => {
    let _id = uuidv4();
    let _itemCrud = {
      esfera_desde: parseFloat(itemCrudLocal.esferaDesde),
      esfera_hasta: parseFloat(itemCrudLocal.esferaHasta),
      cilindro_desde: parseFloat(itemCrudLocal.cilindroDesde),
      cilindro_hasta: parseFloat(itemCrudLocal.cilindroHasta),
      correcciones_list: Array.isArray(itemCrudLocal.correccionesList) ? itemCrudLocal.correccionesList : [],
    };
    if (actionCrud !== "new") {
      _itemCrud.id = itemCrud.id;
    } else {
      _itemCrud.id = _id;
    }
    onSave(_itemCrud, actionCrud);
    setIsDoingSomething(false);

    if (actionCrud !== "new") {
      handleCloseDialog();
    }
    setItemCrudLocal({
      esferaDesde: "",
      esferaHasta: "",
      cilindroDesde: "",
      cilindroHasta: "",
      correccionesList: [],
    });
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Dialog
        open={true}
        onClose={(event, reason) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
            return;
          }
          handleCloseDialog();
        }}
        disableEscapeKeyDown={true}
        maxWidth="sm"
        fullWidth={true}
        scroll="paper"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {nameItemText}
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Grid container spacing={1}>
            <Grid item xs={3} >
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  inputMode: 'decimal',
                  minLength: 1,
                  onInput: (e) => {
                    let val = e.target.value;
                    val = val.replace(/[^0-9.\-]/g, '');
                    if ((val.match(/\./g) || []).length > 1) {
                      val = val.substring(0, val.length - 1);
                    }
                    const hasMinus = val.startsWith('-');
                    val = (hasMinus ? '-' : '') + val.replace(/-/g, '');
                    e.target.value = val;
                  }
                }}
                id="esferaDesde"
                label="Esfera Desde (-30 a 30)"
                variant="outlined"
                size="small"
                name="esferaDesde"
                value={itemCrudLocal.esferaDesde ?? ""}
                onChange={handleChange}
                disabled={true}
              />
            </Grid>

            <Grid item xs={3} >
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  inputMode: 'decimal',
                  minLength: 1,
                  onInput: (e) => {
                    let val = e.target.value;
                    val = val.replace(/[^0-9.\-]/g, '');
                    if ((val.match(/\./g) || []).length > 1) {
                      val = val.substring(0, val.length - 1);
                    }
                    const hasMinus = val.startsWith('-');
                    val = (hasMinus ? '-' : '') + val.replace(/-/g, '');
                    e.target.value = val;
                  }
                }}
                id="esferaHasta"
                label="Esfera Hasta (-30 a 30)"
                variant="outlined"
                size="small"
                name="esferaHasta"
                value={itemCrudLocal.esferaHasta ?? ""}
                onChange={handleChange}
                disabled={true}
              />
            </Grid>

            <Grid item xs={3} >
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  inputMode: 'decimal',
                  minLength: 1,
                  onInput: (e) => {
                    let val = e.target.value;
                    val = val.replace(/[^0-9.\-]/g, '');
                    if ((val.match(/\./g) || []).length > 1) {
                      val = val.substring(0, val.length - 1);
                    }
                    const hasMinus = val.startsWith('-');
                    val = (hasMinus ? '-' : '') + val.replace(/-/g, '');
                    e.target.value = val;
                  }
                }}
                id="cilindroDesde"
                label="Cilindro Desde (-10 a 0)"
                variant="outlined"
                size="small"
                name="cilindroDesde"
                value={itemCrudLocal.cilindroDesde ?? ""}
                onChange={handleChange}
                disabled={true}
              />
            </Grid>

            <Grid item xs={3} >
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  inputMode: 'decimal',
                  minLength: 1,
                  onInput: (e) => {
                    let val = e.target.value;
                    val = val.replace(/[^0-9.\-]/g, '');
                    if ((val.match(/\./g) || []).length > 1) {
                      val = val.substring(0, val.length - 1);
                    }
                    const hasMinus = val.startsWith('-');
                    val = (hasMinus ? '-' : '') + val.replace(/-/g, '');
                    e.target.value = val;
                  }
                }}
                id="cilindroHasta"
                label="Cilindro Hasta (-10 a 0)"
                variant="outlined"
                size="small"
                name="cilindroHasta"
                value={itemCrudLocal.cilindroHasta ?? ""}
                onChange={handleChange}
                disabled={true}
              />
            </Grid>

            <Grid item xs={12} md={12} lg={4}>
              <Autocomplete
                id="id-esfera"
                size="small"
                sx={{ width: "100%" }}
                multiple
                limitTags={1}
                openOnFocus
                disableCloseOnSelect
                value={valueACEsfera || []}
                onChange={(event, newValue, reason, details) => {
                  const lastOption = details && details.option ? details.option : null;
                  if (lastOption && lastOption.__action) {
                    if (allEsferasSelected) {
                      handleClearAllEsferas();
                    } else {
                      handleSelectAllEsferas();
                    }
                    return;
                  }
                  setValueACEsfera(newValue);
                }}
                inputValue={inputValueACEsfera}
                onInputChange={(event, newInputValue) => {
                  setInputValueACEsfera(newInputValue);
                }}
                options={esferaOptionsWithActions}
                isOptionEqualToValue={(option, value) => {
                  if (!option || !value) return false;
                  if (option.__action || value.__action) return option.id === value.id;
                  return option.id === value.id;
                }}
                getOptionLabel={(option) => option.label || ""}
                renderTags={(selected, getTagProps) => {
                  const visibleChips = 3;
                  const chips = selected.slice(0, visibleChips).map((option, index) => (
                    <Chip
                      {...getTagProps({ index })}
                      key={option.id}
                      label={option.label}
                      size="small"
                    />
                  ));
                  if (selected.length > visibleChips) {
                    chips.push(
                      <Chip key="more" label={`+${selected.length - visibleChips}`} size="small" disabled />
                    );
                  }
                  return chips;
                }}
                disableClearable={true}
                disabled={actionCrud === "disable" || actionCrud === "enable" || actionCrud === "delete" || actionCrud === "view"}
                renderOption={(props, option, { selected }) => {
                  const { key, ...optionProps } = props;
                  if (option.__action) {
                    return (
                      <li key={key} {...optionProps}>
                        <Checkbox
                          indeterminate={!allEsferasSelected && Array.isArray(valueACEsfera) && valueACEsfera.length > 0}
                          checked={allEsferasSelected}
                          style={{ marginRight: 5 }}
                        />
                        {allEsferasSelected ? "Desmarcar todos" : "Marcar todos"}
                      </li>
                    );
                  }
                  return (
                    <li key={key} {...optionProps}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 5 }}
                        checked={selected}
                      />
                      {option.label}
                    </li>
                  );
                }}
                renderInput={(params) => <TextField {...params} label="Esfera" />}
              />
            </Grid>

            <Grid item xs={12} md={12} lg={4}>
              <Autocomplete
                id="id-cilindro"
                size="small"
                sx={{ width: "100%" }}
                multiple
                limitTags={1}
                openOnFocus
                disableCloseOnSelect
                value={valueACCilindro || []}
                onChange={(event, newValue, reason, details) => {
                  const lastOption = details && details.option ? details.option : null;
                  if (lastOption && lastOption.__action) {
                    if (allCilindrosSelected) {
                      handleClearAllCilindros();
                    } else {
                      handleSelectAllCilindros();
                    }
                    return;
                  }
                  setValueACCilindro(newValue);
                }}
                inputValue={inputValueACCilindro}
                onInputChange={(event, newInputValue) => {
                  setInputValueACCilindro(newInputValue);
                }}
                options={cilindroOptionsWithActions}
                isOptionEqualToValue={(option, value) => {
                  if (!option || !value) return false;
                  if (option.__action || value.__action) return option.id === value.id;
                  return option.id === value.id;
                }}
                getOptionLabel={(option) => option.label || ""}
                renderTags={(selected, getTagProps) => {
                  const visibleChips = 3;
                  const chips = selected.slice(0, visibleChips).map((option, index) => (
                    <Chip
                      {...getTagProps({ index })}
                      key={option.id}
                      label={option.label}
                      size="small"
                    />
                  ));
                  if (selected.length > visibleChips) {
                    chips.push(
                      <Chip key="more" label={`+${selected.length - visibleChips}`} size="small" disabled />
                    );
                  }
                  return chips;
                }}
                disableClearable={true}
                disabled={actionCrud === "disable" || actionCrud === "enable" || actionCrud === "delete" || actionCrud === "view"}
                renderOption={(props, option, { selected }) => {
                  const { key, ...optionProps } = props;
                  if (option.__action) {
                    return (
                      <li key={key} {...optionProps}>
                        <Checkbox
                          indeterminate={!allCilindrosSelected && Array.isArray(valueACCilindro) && valueACCilindro.length > 0}
                          checked={allCilindrosSelected}
                          style={{ marginRight: 5 }}
                        />
                        {allCilindrosSelected ? "Desmarcar todos" : "Marcar todos"}
                      </li>
                    );
                  }
                  return (
                    <li key={key} {...optionProps}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 5 }}
                        checked={selected}
                      />
                      {option.label}
                    </li>
                  );
                }}
                renderInput={(params) => <TextField {...params} label="Cilindro" />}
              />
            </Grid>

            <Grid item xs={12} md={12} lg={4}>
              <Autocomplete
                id="id-eje"
                size="small"
                sx={{ width: "100%" }}
                multiple
                limitTags={1}
                openOnFocus
                disableCloseOnSelect
                value={valueACEje || []}
                onChange={(event, newValue, reason, details) => {
                  const lastOption = details && details.option ? details.option : null;
                  if (lastOption && lastOption.__action) {
                    if (allEjesSelected) {
                      handleClearAllEjes();
                    } else {
                      handleSelectAllEjes();
                    }
                    return;
                  }
                  setValueACEje(newValue);
                }}
                inputValue={inputValueACEje}
                onInputChange={(event, newInputValue) => {
                  setInputValueACEje(newInputValue);
                }}
                options={ejesOptionsWithActions}
                isOptionEqualToValue={(option, value) => {
                  if (!option || !value) return false;
                  if (option.__action || value.__action) return option.id === value.id;
                  return option.id === value.id;
                }}
                getOptionLabel={(option) => option.label || ""}
                renderTags={(selected, getTagProps) => {
                  const visibleChips = 3;
                  const chips = selected.slice(0, visibleChips).map((option, index) => (
                    <Chip
                      {...getTagProps({ index })}
                      key={option.id}
                      label={option.label}
                      size="small"
                    />
                  ));
                  if (selected.length > visibleChips) {
                    chips.push(
                      <Chip key="more" label={`+${selected.length - visibleChips}`} size="small" disabled />
                    );
                  }
                  return chips;
                }}
                disableClearable={true}
                disabled={
                  actionCrud === "disable" ||
                  actionCrud === "enable" ||
                  actionCrud === "delete" ||
                  actionCrud === "view" ||
                  valueACCilindro.some(opt => opt.id === 0)}
                renderOption={(props, option, { selected }) => {
                  const { key, ...optionProps } = props;
                  if (option.__action) {
                    return (
                      <li key={key} {...optionProps}>
                        <Checkbox
                          indeterminate={!allEjesSelected && Array.isArray(valueACEje) && valueACEje.length > 0}
                          checked={allEjesSelected}
                          style={{ marginRight: 5 }}
                        />
                        {allEjesSelected ? "Desmarcar todos" : "Marcar todos"}
                      </li>
                    );
                  }
                  return (
                    <li key={key} {...optionProps}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 5 }}
                        checked={selected}
                      />
                      {option.label}
                    </li>
                  );
                }}
                renderInput={(params) => <TextField {...params} label="Ejes" />}
              />
            </Grid>

            <Grid item xs={12}>
              <Box
                sx={{ display: "flex", justifyContent: "flex-start", py: 1 }}
              >
                <Tooltip title="nuevo rango">
                  <span>
                    <Button
                      className="btn-add"
                      variant="contained"
                      onClick={() => handleClickCorreccion({}, "new")}
                    // startIcon={<Add />}
                    >
                      Agregar correcciones
                    </Button>
                  </span>
                </Tooltip>
              </Box>
            </Grid>
          </Grid>

          <Typography variant="h6" sx={{ mb: 1 }}>
            Correcciones ({correccionesList.length})
          </Typography>
          <DataGrid
            rows={correccionesSorted || []}
            columns={tableColumnsCorreccionesList}
            {...tableOptionsCorreccionesList}
            sx={{ width: "100%" }}
          />

          <Grid item xs={12}>
            <Box
              sx={{ display: "flex", justifyContent: "flex-end", pt: 1 }}
            >
              <Button
                sx={{ mr: 1 }}
                variant="contained"
                size="small"
                onClick={handleSave}
                color="primary"
                startIcon={<SaveIcon />}
              >
                Guardar
              </Button>

              <Button
                variant="outlined"
                size="small"
                onClick={handleCloseDialog}
              >
                Cancelar
              </Button>
            </Box>
          </Grid>
        </DialogContent>
      </Dialog >
      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default CorreccionesDialog;
